import { render } from "./TournamentPosition.vue?vue&type=template&id=63a75b02&ts=true"
import script from "./TournamentPosition.vue?vue&type=script&lang=ts"
export * from "./TournamentPosition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__